// src/utils/preloadImages.js
// Précharge une liste d'URLs d'images en arrière-plan (met en cache navigateur)

export const preloadImages = (urls = []) => {
    urls.filter(Boolean).forEach((url) => {
      const img = new Image();
      img.src = url;
    });
  };